import { Script } from "gatsby"
import { useActiveEnv } from "@hooks/use-active-env"
import readCookie from "@utils/read-cookie"
import readSubcookie from "@utils/read-subcookie"

const OneTrust = () => {
  let dds = "d8606fe0-eb46-49e2-9118-e39304fc0f7b"
  if (useActiveEnv() !== "production") {
    dds += "-test"
  }

  const consentCookiePresent = readCookie("OptanonConsent")
  const alertBoxClosed = readCookie("OptanonAlertBoxClosed")
  let acceptsAllCookieTypes = false
  let preferenceVals = null
  if (consentCookiePresent) {
    const groups = readSubcookie(consentCookiePresent, "groups")
    if (groups) {
      // Consented categories are expected to be a comma separated string of 3 key:boolean pairs
      // e.g. groups=req:1,funcs:1,adv:0
      // Groups and total count are defined within the CookiePro service
      const groupsArray = groups.split(",").filter((group) => group.includes(":1"))
      acceptsAllCookieTypes = groupsArray.length === 3
      preferenceVals = groupsArray.join(",").replace(/:1/g, "")
    }
  }

  const cookieProScript = (
    <Script type="text/javascript">{`
      (function() {
          var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.charset = "UTF-8";
            s.setAttribute('data-document-language','true');
            s.setAttribute('data-domain-script','${dds}');
            s.src = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

            document.getElementsByTagName('head')[0].appendChild(s);
      })();
      function OptanonWrapper() { }
    `}</Script>
  )

  const pushOnetrustDataLayer = (
    <Script type="text/javascript">{`
      if(!dataLayer){ var dataLayer=[]; }
      dataLayer.push({
        'event': 'OneTrustLoaded',
        'OnetrustActiveGroups': '${preferenceVals}'
      },{
        'event': 'OptanonLoaded',
        'OptanonActiveGroups': '${preferenceVals}'
      },{
        'event': 'OneTrustGroupsUpdated',
        'OnetrustActiveGroups': '${preferenceVals}'
      });
    `}</Script>
  )

  let cookieScript = cookieProScript
  // if condition is true, simulate CookieProScript behavior to trigger GTM workflows.
  // Note: alertBoxClosed is our signal that the user has interacted with the cookie banner, setting their consent preferences
  if (alertBoxClosed || acceptsAllCookieTypes) {
    cookieScript = pushOnetrustDataLayer
  }

  return <>{cookieScript}</>
}

export default OneTrust
